export default __webpack_public_path__ + "static/media/Minicard_Qc.2b2d875a.svg";